import React, { Component } from 'react';
import nl2br from 'react-nl2br';
import {
  Row,
  Col,
} from 'reactstrap';
import Link from 'react-router-dom/Link';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import photo from '../../assets/flea-market.jpg';

const Container = styled.div`
  margin-top: 130px;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 2rem;
`;

const SubTitle = styled.h4`
  text-align: center;
  margin-top: 0px;
  margin-bottom: 1.75rem;
`;

const Description = styled.p`
  text-align: center;
`;

class FleaMarket extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 0);
  }

  render() {
    const { intl } = this.props;

    return (
      <Container className="marketing container">
        <Row className="featurette">
          <Col md={{ size: 10, offset: 1 }}>
            <Title className="featurette-heading">
              {nl2br(intl.formatMessage({
                id: 'FleaMarket.Title',
              }))}
            </Title>
            <SubTitle>
              {nl2br(intl.formatMessage({
                id: 'FleaMarket.SubTitle',
              }))}
            </SubTitle>
          </Col>
        </Row>
        <Row style={{ marginTop: '2rem' }}>
          <Col md={{ size: 8, offset: 2 }}>
            <SubTitle>
              <FormattedMessage id="Workshop.Join.Title" />
            </SubTitle>
            <ul>
              <li>
                <FormattedMessage id="Workshop.Join.1" />
              </li>
              <li>
                <FormattedMessage id="Workshop.Join.2" />
              </li>
              <li>
                <FormattedMessage id="Workshop.Join.3" />
              </li>
              <li>
                <FormattedMessage id="Workshop.Join.4" />
              </li>
              <li>
                <FormattedMessage id="Workshop.Join.5" />
              </li>
              <li>
                <FormattedMessage id="Workshop.Join.6" />
              </li>
            </ul>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={{ size: 8, offset: 2 }}>
            <img
              src={photo}
              alt="workshop"
              className="img-fluid rounded"
            />
            <SubTitle style={{ marginBottom: '0.5rem', marginTop: '2rem' }}>
              <FormattedMessage id="Workshop.JoinEvent" />
            </SubTitle>
            <div className="d-flex flex-row justify-content-center">
              <Link
                to="/contact-us"
                className="btn btn-md btn-primary"
              >
                <FormattedMessage id="Navbar.ContactUs" />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default injectIntl(FleaMarket);
